import {
  AppBar,
  Box,
  Card,
  Grid,
  Icon,
  IconButton,
  Tab,
  Tabs,
  TextField,
  Tooltip,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import breakpoints from "assets/theme/base/breakpoints";
import MDBox from "components/MDBox";
import PropTypes from "prop-types";
import {
  Business,
  ContactPhone,
  MonetizationOn,
  Share,
} from "@mui/icons-material";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { useDispatch, useSelector } from "react-redux";
import { useMaterialUIController } from "context";
import SkLoading from "components/SkLoading";
import { skCompany } from "redux/festures/isCompany";
import ImagePicker from "components/ApnaUploader";
import { handleAlert } from "redux/festures/alertSlice";
import axios from "axios";
import MDInput from "components/MDInput";

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`company-tabpanel-${index}`}
      aria-labelledby={`company-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: { xs: 1, md: 2 } }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

const FieldCard = ({ title, currentValue, isImage, imageSize, previewUrl, children }) => {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  return (
    <MDBox
      sx={({ palette: { dark, white } }) => ({
        display: "flex",
        flexDirection: "column",
        width: "100%",
        gap: 1.5,
        p: 2.5,
        border: 1,
        borderColor: darkMode ? "rgba(255, 255, 255, 0.15)" : "rgba(0, 0, 0, 0.1)",
        borderRadius: 2,
        backgroundColor: darkMode ? "rgba(255, 255, 255, 0.02)" : "rgba(0, 0, 0, 0.01)",
        mb: 2,
      })}
    >
      <MDBox display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={1}>
        <MDTypography variant="h6" color={darkMode ? "white" : "dark"}>
          {title}
          {imageSize && (
            <MDTypography variant="caption" component="span" sx={{ color: "#9e9e9e", ml: 1, fontWeight: "normal" }}>
              ( image size - {imageSize} )
            </MDTypography>
          )}
        </MDTypography>
        {!isImage && currentValue !== undefined && currentValue !== null && currentValue !== "" && (
          <MDTypography
            variant="button"
            color="info"
            fontWeight="regular"
            sx={{
              maxWidth: { xs: "100%", md: "60%" },
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            Current: <strong>{String(currentValue)}</strong>
          </MDTypography>
        )}
      </MDBox>

      {isImage && previewUrl && (
        <MDBox sx={{ maxWidth: 260, maxHeight: 120, my: 1 }}>
          <img
            src={`${process.env.REACT_APP_URI}${previewUrl}`}
            alt={title}
            style={{
              maxHeight: 100,
              maxWidth: "100%",
              objectFit: "contain",
              borderRadius: 6,
            }}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = require("../../assets/images/bg-sign-up-cover.jpeg");
            }}
          />
        </MDBox>
      )}

      <Box
        sx={{
          display: "flex",
          gap: 2,
          width: "100%",
          alignItems: "center",
          flexDirection: { xs: "column", sm: "row" },
        }}
      >
        {children}
      </Box>
    </MDBox>
  );
};

FieldCard.propTypes = {
  title: PropTypes.string.isRequired,
  currentValue: PropTypes.any,
  isImage: PropTypes.bool,
  imageSize: PropTypes.string,
  previewUrl: PropTypes.string,
  children: PropTypes.node.isRequired,
};

const BasicTabs = () => {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const admin = localStorage.getItem("admin_id");
  const dispatch = useDispatch();

  const [tabsOrientation, setTabsOrientation] = useState("horizontal");
  const [tabValue, setTabValue] = useState(0);

  // Form State
  const [siteName, setSiteName] = useState("");
  const [themeColor, setThemeColor] = useState("");
  const [fontStyle, setFontStyle] = useState("");

  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [phone1, setPhone1] = useState("");
  const [whatsapp, setWhatsapp] = useState("");
  const [address, setAddress] = useState("");
  const [gst, setGst] = useState("");
  const [mapLat, setMapLat] = useState("");
  const [mapLng, setMapLng] = useState("");

  const [adminCharge, setAdminCharge] = useState("");
  const [defaultTaxPercent, setDefaultTaxPercent] = useState("");
  const [productDeliveryFee, setProductDeliveryFee] = useState("");
  const [minDelAmount, setMinDelAmount] = useState("");

  const [banner, setBanner] = useState("");
  const [headerLogo, setHeaderLogo] = useState("");
  const [footerLogo, setFooterLogo] = useState("");
  const [favIcon, setFavIcon] = useState("");
  const [signatory, setSignatory] = useState("");
  const [loader, setLoader] = useState("");

  const [footerDescription, setFooterDescription] = useState("");
  const [footerAbout, setFooterAbout] = useState("");
  const [seoKeyword, setSeoKeyword] = useState("");
  const [seoDescription, setSeoDescription] = useState("");
  const [playstoreLink, setPlaystoreLink] = useState("");

  const [facebook, setFacebook] = useState("");
  const [instagram, setInstagram] = useState("");
  const [linkedin, setLinkedin] = useState("");
  const [twitter, setTwitter] = useState("");
  const [youtube, setYoutube] = useState("");
  const [pinterest, setPinterest] = useState("");
  const [googleMyBusiness, setGoogleMyBusiness] = useState("");

  const { Loading, companyData } = useSelector((state) => state.isCompany);

  useEffect(() => {
    dispatch(skCompany({ url: `/getCompanyByAdmin/${admin}` }));
  }, [dispatch, admin]);

  useEffect(() => {
    if (companyData) {
      setSiteName(companyData?.site_name || "");
      setThemeColor(companyData?.theme_color || "#ff34fe");
      setFontStyle(companyData?.font_Style || "");

      setEmail(companyData?.email || "");
      setPhone(companyData?.phone || "");
      setPhone1(companyData?.phone1 || "");
      setWhatsapp(companyData?.whastapp || "");
      setAddress(companyData?.address || "");
      setGst(companyData?.gst || "");
      setMapLat(companyData?.map?.lang !== undefined ? companyData?.map?.lang : "");
      setMapLng(companyData?.map?.long !== undefined ? companyData?.map?.long : "");

      setAdminCharge(companyData?.adminCharge !== undefined ? companyData?.adminCharge : "");
      setDefaultTaxPercent(companyData?.defaultTaxPercent !== undefined ? companyData?.defaultTaxPercent : "");
      setProductDeliveryFee(companyData?.productDeliveryFee !== undefined ? companyData?.productDeliveryFee : "");
      setMinDelAmount(companyData?.minDelAmount !== undefined ? companyData?.minDelAmount : "");

      setFooterDescription(companyData?.footer_description || "");
      setFooterAbout(companyData?.footer_about || "");
      setSeoKeyword(companyData?.seo_keyword || "");
      setSeoDescription(companyData?.seo_description || "");
      setPlaystoreLink(companyData?.playstoreLink || "");

      setFacebook(companyData?.facebook || "");
      setInstagram(companyData?.instagram || "");
      setLinkedin(companyData?.linkedin || "");
      setTwitter(companyData?.twitter || "");
      setYoutube(companyData?.youtube || "");
      setPinterest(companyData?.pinterest || "");
      setGoogleMyBusiness(companyData?.googleMyBusiness || "");
    }
  }, [companyData]);

  useEffect(() => {
    function handleTabsOrientation() {
      return window.innerWidth < breakpoints.values.md
        ? setTabsOrientation("vertical")
        : setTabsOrientation("horizontal");
    }
    window.addEventListener("resize", handleTabsOrientation);
    handleTabsOrientation();
    return () => window.removeEventListener("resize", handleTabsOrientation);
  }, []);

  const isUpdateCompany = async ({ data, content }) => {
    if (!admin) {
      dispatch(handleAlert({ isOpen: true, type: "error", msg: "Admin ID not found" }));
      return;
    }
    const formData = new FormData();
    if (typeof data === "object" && data !== null && !(data instanceof File)) {
      if (Array.isArray(data)) {
        if (data.length > 0 && (data[0] instanceof File || data[0]?.file)) {
          formData.append(content, data[0]?.file || data[0]);
        } else {
          formData.append(content, JSON.stringify(data));
        }
      } else {
        formData.append(content, JSON.stringify(data));
      }
    } else {
      formData.append(content, data);
    }

    try {
      const response = await axios.put(
        `${process.env.REACT_APP_APII}/update/company/${admin}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      dispatch(
        handleAlert({
          isOpen: true,
          type: response?.data?.success ? "success" : "error",
          msg: response?.data?.message || "Updated successfully",
        })
      );
      dispatch(skCompany({ url: `/getCompanyByAdmin/${admin}` }));
    } catch (error) {
      dispatch(
        handleAlert({
          isOpen: true,
          type: "error",
          msg: error?.response?.data?.message || error.message,
        })
      );
    }
  };

  const tabsName = [
    { name: "Company & Branding", icon: <Business /> },
    { name: "Contact & Location", icon: <ContactPhone /> },
    { name: "Charges & Fees", icon: <MonetizationOn /> },
    { name: "Footer, SEO & Social", icon: <Share /> },
  ];

  return (
    <MDBox width="100%">
      <AppBar position="static" sx={{ mb: 3 }}>
        <Tabs
          orientation={tabsOrientation}
          value={tabValue}
          onChange={(e, val) => setTabValue(val)}
          sx={{
            "& .MuiTabs-indicator": {
              backgroundColor: "info.main",
            },
          }}
        >
          {tabsName.map((item, index) => (
            <Tab key={index} label={item.name} icon={item.icon} iconPosition="start" />
          ))}
        </Tabs>
      </AppBar>

      {Loading ? (
        <SkLoading />
      ) : (
        <>
          {/* TAB 0: Company & Branding */}
          <TabPanel value={tabValue} index={0}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <FieldCard title="Website / Company Name" currentValue={companyData?.site_name}>
                  <MDInput
                    fullWidth
                    placeholder="Enter website name"
                    value={siteName}
                    onChange={(e) => setSiteName(e.target.value)}
                  />
                  <MDButton
                    color="info"
                    variant="gradient"
                    onClick={() => isUpdateCompany({ data: siteName, content: "site_name" })}
                  >
                    Update
                  </MDButton>
                </FieldCard>
              </Grid>

              <Grid item xs={12} md={6}>
                <FieldCard title="Theme Primary Color" currentValue={companyData?.theme_color}>
                  <MDInput
                    type="color"
                    sx={{ width: 80, height: 44, p: 0.5, cursor: "pointer" }}
                    value={themeColor}
                    onChange={(e) => setThemeColor(e.target.value)}
                  />
                  <MDInput
                    fullWidth
                    placeholder="#hex code"
                    value={themeColor}
                    onChange={(e) => setThemeColor(e.target.value)}
                  />
                  <MDButton
                    color="info"
                    variant="gradient"
                    onClick={() => isUpdateCompany({ data: themeColor, content: "theme_color" })}
                  >
                    Update
                  </MDButton>
                </FieldCard>
              </Grid>

              <Grid item xs={12} md={6}>
                <FieldCard title="Font Family / Style" currentValue={companyData?.font_Style}>
                  <MDInput
                    fullWidth
                    placeholder="e.g. 'Roboto', 'Inter', sans-serif"
                    value={fontStyle}
                    onChange={(e) => setFontStyle(e.target.value)}
                  />
                  <MDButton
                    color="info"
                    variant="gradient"
                    onClick={() => isUpdateCompany({ data: fontStyle, content: "font_Style" })}
                  >
                    Update
                  </MDButton>
                </FieldCard>
              </Grid>

              <Grid item xs={12} md={6}>
                <FieldCard
                  title="Main Banner"
                  isImage
                  imageSize="1920 × 500 px"
                  previewUrl={companyData?.banner}
                >
                  <ImagePicker name="Banner" multiple={false} images={banner} setImages={setBanner} />
                  <MDButton
                    color="info"
                    variant="gradient"
                    onClick={() => isUpdateCompany({ data: banner, content: "banner" })}
                  >
                    Update
                  </MDButton>
                </FieldCard>
              </Grid>

              <Grid item xs={12} md={6}>
                <FieldCard
                  title="Header Logo"
                  isImage
                  imageSize="200 × 60 px"
                  previewUrl={companyData?.header_logo}
                >
                  <ImagePicker name="Header Logo" multiple={false} images={headerLogo} setImages={setHeaderLogo} />
                  <MDButton
                    color="info"
                    variant="gradient"
                    onClick={() => isUpdateCompany({ data: headerLogo, content: "header_logo" })}
                  >
                    Update
                  </MDButton>
                </FieldCard>
              </Grid>

              <Grid item xs={12} md={6}>
                <FieldCard
                  title="Footer Logo"
                  isImage
                  imageSize="200 × 60 px"
                  previewUrl={companyData?.footer_logo}
                >
                  <ImagePicker name="Footer Logo" multiple={false} images={footerLogo} setImages={setFooterLogo} />
                  <MDButton
                    color="info"
                    variant="gradient"
                    onClick={() => isUpdateCompany({ data: footerLogo, content: "footer_logo" })}
                  >
                    Update
                  </MDButton>
                </FieldCard>
              </Grid>

              <Grid item xs={12} md={6}>
                <FieldCard
                  title="Favicon"
                  isImage
                  imageSize="32 × 32 px"
                  previewUrl={companyData?.fav_icon}
                >
                  <ImagePicker name="Fav Icon" multiple={false} images={favIcon} setImages={setFavIcon} />
                  <MDButton
                    color="info"
                    variant="gradient"
                    onClick={() => isUpdateCompany({ data: favIcon, content: "fav_icon" })}
                  >
                    Update
                  </MDButton>
                </FieldCard>
              </Grid>

              <Grid item xs={12} md={6}>
                <FieldCard
                  title="Invoice Signature"
                  isImage
                  imageSize="200 × 100 px"
                  previewUrl={companyData?.signatory}
                >
                  <ImagePicker name="Signature" multiple={false} images={signatory} setImages={setSignatory} />
                  <MDButton
                    color="info"
                    variant="gradient"
                    onClick={() => isUpdateCompany({ data: signatory, content: "signatory" })}
                  >
                    Update
                  </MDButton>
                </FieldCard>
              </Grid>

              <Grid item xs={12} md={6}>
                <FieldCard
                  title="Loading Spinner / Loader"
                  isImage
                  imageSize="200 × 200 px"
                  previewUrl={companyData?.loader}
                >
                  <ImagePicker name="Loader" multiple={false} images={loader} setImages={setLoader} />
                  <MDButton
                    color="info"
                    variant="gradient"
                    onClick={() => isUpdateCompany({ data: loader, content: "loader" })}
                  >
                    Update
                  </MDButton>
                </FieldCard>
              </Grid>
            </Grid>
          </TabPanel>

          {/* TAB 1: Contact & Location */}
          <TabPanel value={tabValue} index={1}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <FieldCard title="Official Email" currentValue={companyData?.email}>
                  <MDInput
                    type="email"
                    fullWidth
                    placeholder="company@example.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <MDButton
                    color="info"
                    variant="gradient"
                    onClick={() => isUpdateCompany({ data: email, content: "email" })}
                  >
                    Update
                  </MDButton>
                </FieldCard>
              </Grid>

              <Grid item xs={12} md={6}>
                <FieldCard title="Primary Phone Number" currentValue={companyData?.phone}>
                  <MDInput
                    type="number"
                    fullWidth
                    placeholder="Enter phone number"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                  />
                  <MDButton
                    color="info"
                    variant="gradient"
                    onClick={() => isUpdateCompany({ data: phone, content: "phone" })}
                  >
                    Update
                  </MDButton>
                </FieldCard>
              </Grid>

              <Grid item xs={12} md={6}>
                <FieldCard title="Secondary Phone Number (phone1)" currentValue={companyData?.phone1}>
                  <MDInput
                    type="number"
                    fullWidth
                    placeholder="Enter secondary phone number"
                    value={phone1}
                    onChange={(e) => setPhone1(e.target.value)}
                  />
                  <MDButton
                    color="info"
                    variant="gradient"
                    onClick={() => isUpdateCompany({ data: phone1, content: "phone1" })}
                  >
                    Update
                  </MDButton>
                </FieldCard>
              </Grid>

              <Grid item xs={12} md={6}>
                <FieldCard title="WhatsApp Number" currentValue={companyData?.whastapp}>
                  <MDInput
                    type="text"
                    fullWidth
                    placeholder="Enter WhatsApp number"
                    value={whatsapp}
                    onChange={(e) => setWhatsapp(e.target.value)}
                  />
                  <MDButton
                    color="info"
                    variant="gradient"
                    onClick={() => isUpdateCompany({ data: whatsapp, content: "whastapp" })}
                  >
                    Update
                  </MDButton>
                </FieldCard>
              </Grid>

              <Grid item xs={12} md={6}>
                <FieldCard title="GST Number" currentValue={companyData?.gst}>
                  <MDInput
                    type="text"
                    fullWidth
                    placeholder="15-digit GST number"
                    value={gst}
                    onChange={(e) => setGst(e.target.value.toUpperCase())}
                  />
                  <MDButton
                    color="info"
                    variant="gradient"
                    onClick={() => isUpdateCompany({ data: gst, content: "gst" })}
                  >
                    Update
                  </MDButton>
                </FieldCard>
              </Grid>

              <Grid item xs={12} md={6}>
                <FieldCard title="Office Address" currentValue={companyData?.address}>
                  <MDInput
                    type="text"
                    fullWidth
                    multiline
                    rows={2}
                    placeholder="Full company address"
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                  />
                  <MDButton
                    color="info"
                    variant="gradient"
                    onClick={() => isUpdateCompany({ data: address, content: "address" })}
                  >
                    Update
                  </MDButton>
                </FieldCard>
              </Grid>

              <Grid item xs={12}>
                <FieldCard
                  title="Google Map Coordinates (lang / long)"
                  currentValue={`Lat: ${companyData?.map?.lang || 0}, Lng: ${companyData?.map?.long || 0}`}
                >
                  <MDInput
                    type="number"
                    inputProps={{ step: "any" }}
                    placeholder="Latitude (lang)"
                    value={mapLat}
                    onChange={(e) => setMapLat(e.target.value)}
                    sx={{ flex: 1 }}
                  />
                  <MDInput
                    type="number"
                    inputProps={{ step: "any" }}
                    placeholder="Longitude (long)"
                    value={mapLng}
                    onChange={(e) => setMapLng(e.target.value)}
                    sx={{ flex: 1 }}
                  />
                  <MDButton
                    color="info"
                    variant="gradient"
                    onClick={() => {
                      const mapObj = {
                        lang: Number(mapLat) || 0,
                        long: Number(mapLng) || 0,
                      };
                      isUpdateCompany({ data: mapObj, content: "map" });
                    }}
                  >
                    Update
                  </MDButton>
                </FieldCard>
              </Grid>
            </Grid>
          </TabPanel>

          {/* TAB 2: Charges & Fees */}
          <TabPanel value={tabValue} index={2}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <FieldCard title="Admin Charge / Commission (%)" currentValue={`${companyData?.adminCharge || 0}%`}>
                  <MDInput
                    type="number"
                    inputProps={{ min: 0, max: 100, step: "0.01" }}
                    fullWidth
                    placeholder="Admin Commission %"
                    value={adminCharge}
                    onChange={(e) => setAdminCharge(e.target.value)}
                  />
                  <MDButton
                    color="info"
                    variant="gradient"
                    onClick={() => isUpdateCompany({ data: Number(adminCharge), content: "adminCharge" })}
                  >
                    Update
                  </MDButton>
                </FieldCard>
              </Grid>

              <Grid item xs={12} md={6}>
                <FieldCard title="Default Tax Percentage (%)" currentValue={`${companyData?.defaultTaxPercent || 0}%`}>
                  <MDInput
                    type="number"
                    inputProps={{ min: 0, max: 100, step: "0.01" }}
                    fullWidth
                    placeholder="Default Tax %"
                    value={defaultTaxPercent}
                    onChange={(e) => setDefaultTaxPercent(e.target.value)}
                  />
                  <MDButton
                    color="info"
                    variant="gradient"
                    onClick={() =>
                      isUpdateCompany({ data: Number(defaultTaxPercent), content: "defaultTaxPercent" })
                    }
                  >
                    Update
                  </MDButton>
                </FieldCard>
              </Grid>

              <Grid item xs={12} md={6}>
                <FieldCard title="Product Delivery Fee (₹)" currentValue={`₹ ${companyData?.productDeliveryFee || 0}`}>
                  <MDInput
                    type="number"
                    inputProps={{ min: 0, step: "1" }}
                    fullWidth
                    placeholder="Delivery Fee"
                    value={productDeliveryFee}
                    onChange={(e) => setProductDeliveryFee(e.target.value)}
                  />
                  <MDButton
                    color="info"
                    variant="gradient"
                    onClick={() =>
                      isUpdateCompany({ data: Number(productDeliveryFee), content: "productDeliveryFee" })
                    }
                  >
                    Update
                  </MDButton>
                </FieldCard>
              </Grid>

              <Grid item xs={12} md={6}>
                <FieldCard
                  title="Minimum Order Amount For Delivery (₹)"
                  currentValue={`₹ ${companyData?.minDelAmount || 0}`}
                >
                  <MDInput
                    type="number"
                    inputProps={{ min: 0, step: "1" }}
                    fullWidth
                    placeholder="Min Delivery Order Amount"
                    value={minDelAmount}
                    onChange={(e) => setMinDelAmount(e.target.value)}
                  />
                  <MDButton
                    color="info"
                    variant="gradient"
                    onClick={() => isUpdateCompany({ data: Number(minDelAmount), content: "minDelAmount" })}
                  >
                    Update
                  </MDButton>
                </FieldCard>
              </Grid>
            </Grid>
          </TabPanel>

          {/* TAB 3: Footer, SEO & Social */}
          <TabPanel value={tabValue} index={3}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <FieldCard title="Footer Copyright Description" currentValue={companyData?.footer_description}>
                  <MDInput
                    fullWidth
                    placeholder="e.g. © 2026 Company Name. All Rights Reserved."
                    value={footerDescription}
                    onChange={(e) => setFooterDescription(e.target.value)}
                  />
                  <MDButton
                    color="info"
                    variant="gradient"
                    onClick={() =>
                      isUpdateCompany({ data: footerDescription, content: "footer_description" })
                    }
                  >
                    Update
                  </MDButton>
                </FieldCard>
              </Grid>

              <Grid item xs={12}>
                <FieldCard title="Footer About Short Text" currentValue={companyData?.footer_about}>
                  <MDInput
                    fullWidth
                    multiline
                    rows={2}
                    placeholder="Short about snippet displayed in the footer"
                    value={footerAbout}
                    onChange={(e) => setFooterAbout(e.target.value)}
                  />
                  <MDButton
                    color="info"
                    variant="gradient"
                    onClick={() => isUpdateCompany({ data: footerAbout, content: "footer_about" })}
                  >
                    Update
                  </MDButton>
                </FieldCard>
              </Grid>

              <Grid item xs={12} md={6}>
                <FieldCard title="SEO Meta Keywords" currentValue={companyData?.seo_keyword}>
                  <MDInput
                    fullWidth
                    placeholder="keyword1, keyword2, keyword3"
                    value={seoKeyword}
                    onChange={(e) => setSeoKeyword(e.target.value)}
                  />
                  <MDButton
                    color="info"
                    variant="gradient"
                    onClick={() => isUpdateCompany({ data: seoKeyword, content: "seo_keyword" })}
                  >
                    Update
                  </MDButton>
                </FieldCard>
              </Grid>

              <Grid item xs={12} md={6}>
                <FieldCard title="SEO Meta Description" currentValue={companyData?.seo_description}>
                  <MDInput
                    fullWidth
                    placeholder="SEO description"
                    value={seoDescription}
                    onChange={(e) => setSeoDescription(e.target.value)}
                  />
                  <MDButton
                    color="info"
                    variant="gradient"
                    onClick={() => isUpdateCompany({ data: seoDescription, content: "seo_description" })}
                  >
                    Update
                  </MDButton>
                </FieldCard>
              </Grid>

              <Grid item xs={12}>
                <FieldCard title="Google Play Store Link" currentValue={companyData?.playstoreLink}>
                  <MDInput
                    fullWidth
                    placeholder="https://play.google.com/store/apps/details?id=..."
                    value={playstoreLink}
                    onChange={(e) => setPlaystoreLink(e.target.value)}
                  />
                  <MDButton
                    color="info"
                    variant="gradient"
                    onClick={() => isUpdateCompany({ data: playstoreLink, content: "playstoreLink" })}
                  >
                    Update
                  </MDButton>
                </FieldCard>
              </Grid>

              <Grid item xs={12} md={6}>
                <FieldCard title="Facebook Page URL" currentValue={companyData?.facebook}>
                  <MDInput
                    fullWidth
                    placeholder="https://facebook.com/..."
                    value={facebook}
                    onChange={(e) => setFacebook(e.target.value)}
                  />
                  <MDButton
                    color="info"
                    variant="gradient"
                    onClick={() => isUpdateCompany({ data: facebook, content: "facebook" })}
                  >
                    Update
                  </MDButton>
                </FieldCard>
              </Grid>

              <Grid item xs={12} md={6}>
                <FieldCard title="Instagram Profile URL" currentValue={companyData?.instagram}>
                  <MDInput
                    fullWidth
                    placeholder="https://instagram.com/..."
                    value={instagram}
                    onChange={(e) => setInstagram(e.target.value)}
                  />
                  <MDButton
                    color="info"
                    variant="gradient"
                    onClick={() => isUpdateCompany({ data: instagram, content: "instagram" })}
                  >
                    Update
                  </MDButton>
                </FieldCard>
              </Grid>

              <Grid item xs={12} md={6}>
                <FieldCard title="LinkedIn Profile URL" currentValue={companyData?.linkedin}>
                  <MDInput
                    fullWidth
                    placeholder="https://linkedin.com/in/..."
                    value={linkedin}
                    onChange={(e) => setLinkedin(e.target.value)}
                  />
                  <MDButton
                    color="info"
                    variant="gradient"
                    onClick={() => isUpdateCompany({ data: linkedin, content: "linkedin" })}
                  >
                    Update
                  </MDButton>
                </FieldCard>
              </Grid>

              <Grid item xs={12} md={6}>
                <FieldCard title="Twitter / X Profile URL" currentValue={companyData?.twitter}>
                  <MDInput
                    fullWidth
                    placeholder="https://twitter.com/..."
                    value={twitter}
                    onChange={(e) => setTwitter(e.target.value)}
                  />
                  <MDButton
                    color="info"
                    variant="gradient"
                    onClick={() => isUpdateCompany({ data: twitter, content: "twitter" })}
                  >
                    Update
                  </MDButton>
                </FieldCard>
              </Grid>

              <Grid item xs={12} md={6}>
                <FieldCard title="YouTube Channel URL" currentValue={companyData?.youtube}>
                  <MDInput
                    fullWidth
                    placeholder="https://youtube.com/@..."
                    value={youtube}
                    onChange={(e) => setYoutube(e.target.value)}
                  />
                  <MDButton
                    color="info"
                    variant="gradient"
                    onClick={() => isUpdateCompany({ data: youtube, content: "youtube" })}
                  >
                    Update
                  </MDButton>
                </FieldCard>
              </Grid>

              <Grid item xs={12} md={6}>
                <FieldCard title="Pinterest Profile URL" currentValue={companyData?.pinterest}>
                  <MDInput
                    fullWidth
                    placeholder="https://pinterest.com/..."
                    value={pinterest}
                    onChange={(e) => setPinterest(e.target.value)}
                  />
                  <MDButton
                    color="info"
                    variant="gradient"
                    onClick={() => isUpdateCompany({ data: pinterest, content: "pinterest" })}
                  >
                    Update
                  </MDButton>
                </FieldCard>
              </Grid>

              <Grid item xs={12}>
                <FieldCard title="Google My Business URL" currentValue={companyData?.googleMyBusiness}>
                  <MDInput
                    fullWidth
                    placeholder="https://g.page/..."
                    value={googleMyBusiness}
                    onChange={(e) => setGoogleMyBusiness(e.target.value)}
                  />
                  <MDButton
                    color="info"
                    variant="gradient"
                    onClick={() =>
                      isUpdateCompany({ data: googleMyBusiness, content: "googleMyBusiness" })
                    }
                  >
                    Update
                  </MDButton>
                </FieldCard>
              </Grid>
            </Grid>
          </TabPanel>
        </>
      )}
    </MDBox>
  );
};

export default BasicTabs;
